export default __webpack_public_path__ + "static/media/special-processes.13384e82.svg";